/**
 * Colors any country with at least one petition signature on the MapSVG
 * "Campaign progress" map. Handled entirely here rather than via a MapSVG
 * event hook: MapSVG renders the world.svg's <path id="XX"> regions inside
 * a closed shadow root (div.mapsvg-shadow-root), and the map's own JS-level
 * region API (map.regions) was found empty/undefined at every hook we tried
 * on this install — so we skip MapSVG's object model and color the <path>
 * elements directly, which only needs the DOM to exist.
 *
 * The per-country stats popup itself is handled natively by MapSVG's own
 * "Region Popover" (Menu > Templates > Region Popover in its admin), reading
 * from wp_mapsvg6_regions_1 — kept in sync by ifcc_petition_sync_mapsvg_region()
 * in public/plugins/ifcc/petition-signatures.php whenever a signature is
 * added or updated. No custom click handling needed here.
 */
(function () {
    function colorSignedCountries(codes) {
        var shadowHost = document.querySelector('.mapmap .mapsvg-shadow-root');
        if (!shadowHost || !shadowHost.shadowRoot || !codes || !codes.length) return false;

        var paths = shadowHost.shadowRoot.querySelectorAll('path[id]');
        if (!paths.length) return false;

        paths.forEach(function (path) {
            if (codes.indexOf(path.id) !== -1) {
                // Ember — the map's own default region fill is already
                // bloom green, so a "signed" highlight needs real contrast.
                path.style.fill = '#e66226';
            }
        });
        return true;
    }

    function fetchAndColorSignedCountries() {
        if (!window.ifccPetition) return;

        fetch(window.ifccPetition.ajaxUrl + '?action=ifcc_petition_signed_countries')
            .then(function (response) { return response.json(); })
            .then(function (result) {
                if (!result.success) return;

                var codes = result.data.codes;
                var attempts = 0;

                // The map's shadow DOM renders asynchronously after page load,
                // so poll briefly for it rather than assuming a fixed delay.
                var interval = window.setInterval(function () {
                    attempts += 1;
                    if (colorSignedCountries(codes) || attempts > 20) {
                        window.clearInterval(interval);
                    }
                }, 250);
            });
    }

    if (document.querySelector('.mapmap')) {
        fetchAndColorSignedCountries();
    }
})();
